import { RootState } from '@/store';

export const transactionsSelector = (state: RootState) => {
  return state.affiliateProgramStore.transactions;
};
